import DataServiceSQL from "../DataService/DataServiceSQL";

const convert_fhir_request = (linkage_list) => {
/*
profile_serial_number
: 
null
recipient_mail_address
: 
"romain.rhyn@e-takescare.com"
request_id
: 
160
requester_mail_address
: 
"testadmin@e-takescare.com"
requester_struct_name
: 
"structure test"
token
: 
null
*/
  let ret = []
  let i = 0;
  linkage_list.forEach(linkage => {
    if (linkage.active === false) {
      let requester_data = linkage.item.find(element => element.resource.type === "Practitioner")
      let new_element = {
        request_id: i,
        recipient_mail_address: linkage.author,
        requester_mail_address: requester_data.resource.reference,
        requester_struct_name: requester_data.resource.display
      }
      ret.push(new_element)
      i++;
    }
  });
  return ret
};

const get_requests_received_list = async (recipient_mail_address) => {
  try {
    const response = await DataServiceSQL.getRequestsReceivedListSQL(recipient_mail_address);
    if (response && Array.isArray(response.data) && response.data.length > 0) {
      return response.data;
    }
    return null;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const get_requests_sent_list = async () => {
  return await DataServiceSQL.getLinkage_fhir("ongoing_only")
    .then((response) => {
      if(response !== undefined){
        if((response.data.entry !== undefined)&&(response.data.entry.length > 0)){
          let ret = convert_fhir_request(response.data.entry)
          return(ret);
        }      
        else{
          return(null)
        }
      }
      else{
        return(null)
      }
    })
    .catch((e) => {
      console.log(e);
    });
};

// Fetch sent structure invitations (pending + accepted) and convert them into
// a unified shape compatible with ItemListSentRequest. Each entry carries an
// `item_type` discriminator so the UI knows which fields to display.
const get_sent_structure_invitations = async () => {
  try {
    const response = await DataServiceSQL.getSentStructureInvitations();
    if (!response || !response.data) return { pending: [], accepted: [] };
    const data = response.data || {};

    const patientLabel = (row) => {
      const fn = row.patient_firstname || '';
      const ln = row.patient_lastname || '';
      const full = (fn + ' ' + ln).trim();
      return full || row.FK_patient || row.id_patient || '';
    };

    const pending = (data.pending || []).map((row) => ({
      item_type: 'structure_pending',
      request_id: row.request_id,
      FK_patient: row.FK_patient,
      patient_label: patientLabel(row),
      recipient_structure_id: row.recipient_structure_id,
      recipient_structure_name: row.recipient_structure_name || row.recipient_structure_id,
      delegate_name: row.delegate_name,
      delegate_phone: row.delegate_phone,
    }));

    const accepted = (data.accepted || []).map((row) => ({
      item_type: 'structure_accepted',
      id_patient: row.id_patient,
      patient_label: patientLabel(row),
      id_structure: row.id_structure,
      structure_name: row.structure_name || row.id_structure,
      sharing_type: row.sharing_type,
      permission: row.permission,
      granted_at: row.granted_at,
    }));

    return { pending, accepted };
  } catch (e) {
    console.log(e);
    return { pending: [], accepted: [] };
  }
};


//Const to import functions in other files
const CreationRequestsGetter = {
  get_requests_received_list,
  get_requests_sent_list,
  get_sent_structure_invitations
};

export default CreationRequestsGetter;